import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

/* 配置类型：1-定时补偿配置，2-异常回执预警，3-通道异常预警 */
export const MESSAGE_POLICY_CFG_TYPE = GenerateEnum({
  SCHEDULE_COMPENSATION: { value: 1, label: getLabelText({ key: 'remote.common.complianceTypeScheduleCompensation', text: '定时补偿配置' }) },
  ASYNC_WARNING: { value: 2, label: getLabelText({ key: 'remote.common.complianceTypeAsyncWarning', text: '异常回执预警' }) },
  EXCEPTION_WARNING: { value: 3, label: getLabelText({ key: 'remote.common.complianceTypeExceptionWarning', text: '通道异常预警' }) }
})

export const CHANNEL_RECEIPT_CONFIG = [
  {
    channelName: '大汉三通',
    receiptStatuses: [],
    sort: 0
  },
  {
    channelName: '积脉云',
    receiptStatuses: [],
    sort: 1
  }
]



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/messagePolicyCfg.js